import BlackCat from "../../assets/combatants/marvel/black-cat.png";
import BlackCatIcon from "../../assets/combatants/marvel/black-cat-icon.png";
import BlackCatWin from "../../assets/combatants/marvel/black-cat-win.png";
import BlackCatLose from "../../assets/combatants/marvel/black-cat-lose.png";

import BlackWidow from "../../assets/combatants/marvel/black-widow.png";
import BlackWidowIcon from "../../assets/combatants/marvel/black-widow-icon.png";
import BlackWidowWin from "../../assets/combatants/marvel/black-widow-win.png";
import BlackWidowLose from "../../assets/combatants/marvel/black-widow-lose.png";

import EmmaFrost from "../../assets/combatants/marvel/emma-frost.png";
import EmmaFrostIcon from "../../assets/combatants/marvel/emma-frost-icon.png";
import EmmaFrostWin from "../../assets/combatants/marvel/emma-frost-win.png";
import EmmaFrostLose from "../../assets/combatants/marvel/emma-frost-lose.png";

import KittyPryde from "../../assets/combatants/marvel/kitty-pryde.png";
import KittyPrydeIcon from "../../assets/combatants/marvel/kitty-pryde-icon.png";
import KittyPrydeWin from "../../assets/combatants/marvel/kitty-pryde-win.png";
import KittyPrydeLose from "../../assets/combatants/marvel/kitty-pryde-lose.png";

import GwenStacy from "../../assets/combatants/marvel/gwen-stacy.png";
import GwenStacyIcon from "../../assets/combatants/marvel/gwen-stacy-icon.png";
import GwenStacyWin from "../../assets/combatants/marvel/gwen-stacy-win.png";
import GwenStacyLose from "../../assets/combatants/marvel/gwen-stacy-lose.png";

import JeanGrey from "../../assets/combatants/marvel/jean-grey.png";
import JeanGreyIcon from "../../assets/combatants/marvel/jean-grey-icon.png";
import JeanGreyWin from "../../assets/combatants/marvel/jean-grey-win.png";
import JeanGreyLose from "../../assets/combatants/marvel/jean-grey-lose.png";

import Rogue from "../../assets/combatants/marvel/rogue.png";
import RogueIcon from "../../assets/combatants/marvel/rogue-icon.png";
import RogueWin from "../../assets/combatants/marvel/rogue-win.png";
import RogueLose from "../../assets/combatants/marvel/rogue-lose.png";

import MaryJane from "../../assets/combatants/marvel/mary-jane.png";
import MaryJaneIcon from "../../assets/combatants/marvel/mary-jane-icon.png";
import MaryJaneWin from "../../assets/combatants/marvel/mary-jane-win.png";
import MaryJaneLose from "../../assets/combatants/marvel/mary-jane-lose.png";

import X23 from "../../assets/combatants/marvel/x-23.png";
import X23Icon from "../../assets/combatants/marvel/x-23-icon.png";
import X23Win from "../../assets/combatants/marvel/x-23-win.png";
import X23Lose from "../../assets/combatants/marvel/x-23-lose.png";

export const seriesId = "Marvel";

export default {
  blackCat: {
    seriesId,
    id: "blackCat",
    name: "BlackCat Possible",
    description:
      "Black Cat is a former love interest and ally of Spider-Man, she is also a master thief.",
    img: BlackCat,
    icon: BlackCatIcon,
    opWinImg: BlackCatWin,
    opLoseImg: BlackCatLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "buxom",
    eyeColor: "light grey",
    hairColor: "white",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 2,
    prefAttack: "tongue",
    prefTarget: "mouth",
    uniqueAttackText:
      "Black Cat forces her wet tongue into xxxx's mouth, exploring the inside of their mouth.",
    roughPlayLvl: 10,
    seductionResistance: 25,
    grapplingProwess: 35,
    tongueProwess: 34,
    touchProwess: 28,
    cockProwess: 25,
    vaginaProwess: 20,
    anusProwess: 15,
    touchResistance: 25,
    breastResistance: 40,
    mouthResistance: 20,
    cockResistance: 25,
    vaginaResistance: 25,
    anusResistance: 18,
    orgasmLimit: 3,
  },
  blackWidow: {
    seriesId,
    id: "blackWidow",
    name: "Black Widow",
    description: "Originally a KGB operative and dangerous assassin, Black Widow was recruited into S.H.I.E.L.D. by Clint Barton.",
    img: BlackWidow,
    icon: BlackWidowIcon,
    opWinImg: BlackWidowWin,
    opLoseImg: BlackWidowLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "toned",
    eyeColor: "blue",
    hairColor: "red",
    skinColor: "pale",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "touch",
    uniqueAttackText:
      "Black Widow licks xxxx's skin, coating it in saliva, and savouring their taste.",
    roughPlayLvl: 85,
    seductionResistance: 35,
    grapplingProwess: 35,
    tongueProwess: 35,
    touchProwess: 35,
    cockProwess: 20,
    vaginaProwess: 30,
    anusProwess: 15,
    touchResistance: 15,
    breastResistance: 30,
    mouthResistance: 34,
    cockResistance: 30,
    vaginaResistance: 25,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  emmaFrost: {
    seriesId,
    id: "emmaFrost",
    name: "Emma Frost",
    description: "Emma Frost was born in to a wealthy family in Boston, after gaining her powers she became the White Queen of the Hellfire Club.",
    img: EmmaFrost,
    icon: EmmaFrostIcon,
    opWinImg: EmmaFrostWin,
    opLoseImg: EmmaFrostLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "blue",
    hairColor: "white",
    skinColor: "pale",
    height: 3,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "touch",
    prefTarget: "touch",
    uniqueAttackText:
      "Emma massages xxxx's torso with her hands & breasts.",
    roughPlayLvl: 5,
    seductionResistance: 42,
    grapplingProwess: 30,
    tongueProwess: 35,
    touchProwess: 48,
    cockProwess: 25,
    vaginaProwess: 45,
    anusProwess: 45,
    touchResistance: 48,
    breastResistance: 25,
    mouthResistance: 35,
    cockResistance: 25,
    vaginaResistance: 35,
    anusResistance: 15,
    orgasmLimit: 3,
  },
  jeanGrey: {
    seriesId,
    id: "jeanGrey",
    name: "JeanGrey",
    description: "Jean Grey is an evolved mutant with powerful telekinetic and telepathic abilities, further enhanced by the cosmic energies of the Phoenix Force.",
    img: JeanGrey,
    icon: JeanGreyIcon,
    opWinImg: JeanGreyWin,
    opLoseImg: JeanGreyLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "toned",
    eyeColor: "green",
    hairColor: "red",
    skinColor: "pale",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 1,
    throatSize: 2,
    prefAttack: "vagina",
    prefTarget: "mouth",
    uniqueAttackText: "Jean nuzzles xxxx's vaginal lips, before gently lapping their clit'.",
    roughPlayLvl: -5,
    seductionResistance: 45,
    grapplingProwess: 38,
    tongueProwess: 25,
    touchProwess: 25,
    cockProwess: 15,
    vaginaProwess: 35,
    anusProwess: 25,
    // -- resistance is ability to endure pleasure, 1 - 100
    touchResistance: 35,
    breastResistance: 20,
    mouthResistance: 32,
    cockResistance: 15,
    vaginaResistance: 45,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  kittyPryde: {
    seriesId,
    id: "kittyPryde",
    name: "KittyPryde",
    description: "Kitty Pryde is gifted member of the x-men who can pass through solid matter.",
    img: KittyPryde,
    icon: KittyPrydeIcon,
    opWinImg: KittyPrydeWin,
    opLoseImg: KittyPrydeLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "human",
    bodyShape: "curvy",
    eyeColor: "hazel",
    hairColor: "aubrun",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "touch",
    prefTarget: "breasts",
    uniqueAttackText:
      "Kitty's soft hands tease xxxx's breasts and nipples.",
    roughPlayLvl: -15,
    seductionResistance: 35,
    grapplingProwess: 40,
    tongueProwess: 35,
    touchProwess: 35,
    cockProwess: 15,
    vaginaProwess: 35,
    anusProwess: 10,
    touchResistance: 15,
    breastResistance: 45,
    mouthResistance: 20,
    cockResistance: 35,
    vaginaResistance: 15,
    anusResistance: 50,
    orgasmLimit: 3,
  },
  gwenStacy: {
    seriesId,
    id: "gwenStacy",
    name: "GwenStacy",
    description:
      "Gewn is the daughter of a police detective and spiderman's first romance.",
    img: GwenStacy,
    icon: GwenStacyIcon,
    opWinImg: GwenStacyWin,
    opLoseImg: GwenStacyLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "curvaceous",
    eyeColor: "blue",
    hairColor: "blonde",
    skinColor: "pale green",
    height: 1,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "cock",
    uniqueAttackText:
      "Gwen gobbles up xxxx's thick meat pole, deepthroating it as far as she can.",
    roughPlayLvl: 12,
    seductionResistance: 35,
    grapplingProwess: 40,
    tongueProwess: 40,
    touchProwess: 20,
    cockProwess: 25,
    vaginaProwess: 15,
    anusProwess: 25,
    touchResistance: 35,
    breastResistance: 25,
    mouthResistance: 35,
    cockResistance: 25,
    vaginaResistance: 30,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  rogue: {
    seriesId,
    id: "rogue",
    name: "Rogue",
    description:
      "Rogue is a runaway mutant who joined the Brotherhood of Mutants before switching to the x-men.",
    img: Rogue,
    icon: RogueIcon,
    opWinImg: RogueWin,
    opLoseImg: RogueLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "tight",
    eyeColor: "green",
    hairColor: "auburn-white",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "anus",
    uniqueAttackText:
      "Rogue uses her long lavish the inside of xxxx's arse with tender licks.",
    roughPlayLvl: -5,
    seductionResistance: 42,
    grapplingProwess: 45,
    tongueProwess: 42,
    touchProwess: 20,
    cockProwess: 35,
    vaginaProwess: 25,
    anusProwess: 35,
    touchResistance: 25,
    breastResistance: 25,
    mouthResistance: 40,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 15,
    orgasmLimit: 3,
  },
  maryJane: {
    seriesId,
    id: "maryJane",
    name: "MaryJane",
    description:
      "Mary Jane is an investigative journalist for the Daily Bugle, she is a friend and love interest of spiderman.",
    img: MaryJane,
    icon: MaryJaneIcon,
    opWinImg: MaryJaneWin,
    opLoseImg: MaryJaneLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "youthful",
    eyeColor: "green",
    hairColor: "ginger",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 2,
    prefAttack: "touch",
    prefTarget: "vagina",
    uniqueAttackText:
      "MaryJane pushes her fingers roughly into xxxx's dripping cunt.",
    roughPlayLvl: 15,
    seductionResistance: 52,
    grapplingProwess: 42,
    tongueProwess: 25,
    touchProwess: 45,
    cockProwess: 15,
    vaginaProwess: 25,
    anusProwess: 45,
    touchResistance: 55,
    breastResistance: 45,
    mouthResistance: 40,
    cockResistance: 15,
    vaginaResistance: 45,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  x23: {
    seriesId,
    id: "x23",
    name: "X23",
    description:
      "As part of a secret government program, the Facility created a child using the genetic code of Wolverine. She came to be named Laura Kinney, otherwise known as X-23 .",
    img: X23,
    icon: X23Icon,
    opWinImg: X23Win,
    opLoseImg: X23Lose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "toned",
    eyeColor: "black",
    hairColor: "black",
    skinColor: "pale",
    height: 3,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "tongue",
    prefTarget: "breasts",
    uniqueAttackText:
      "X23's long silky tongue, seductively licks xxxx's heaving busom.",
    roughPlayLvl: 10,
    seductionResistance: 38,
    grapplingProwess: 50,
    tongueProwess: 50,
    touchProwess: 20,
    cockProwess: 15,
    vaginaProwess: 20,
    anusProwess: 20,
    touchResistance: 45,
    breastResistance: 25,
    mouthResistance: 25,
    cockResistance: 15,
    vaginaResistance: 52,
    anusResistance: 38,
    orgasmLimit: 3,
  },
};
